import script from "./InputLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputLabel.vue?vue&type=script&setup=true&lang=ts"

import "./InputLabel.vue?vue&type=style&index=0&id=b43af9e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b43af9e6"]])

export default __exports__